import { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import type { AgendaRecordItem } from 'types';
import type { DocumentContext, ResolveDocumentEditing } from 'types/documentEditing';
import { VISIBILITY_STATE } from 'types/enums';
import { isMobileApp } from 'utils/common';
import { useDocumentLaunch } from './useDocumentLaunch';

export const useTableDocumentEditing = (
  agendaId: string,
  records: AgendaRecordItem[] | undefined,
  canEdit: boolean,
  enabled = true
): ResolveDocumentEditing => {
  const launch = useDocumentLaunch();
  const { versionId } = useParams();
  const savedRecords = useMemo(() => new Map((records ?? []).map((record) => [record.id, record])), [records]);
  return useCallback(
    (recordId, formItemId) => {
      if (!enabled || versionId || isMobileApp()) return undefined;
      const record = savedRecords.get(recordId);
      const attribute = record?.attributes.find((item) => item.formItem?.id === formItemId);
      const context: DocumentContext = {
        agendaId: record?.agendaId ?? agendaId,
        recordId,
        persistedFileIds: attribute?.fileUploadAttribute?.values ?? [],
        canEdit: canEdit && record?.state === VISIBILITY_STATE.EDITABLE && attribute?.visibilityResult?.visibilityState === VISIBILITY_STATE.EDITABLE,
      };
      return { context, onOpen: (file, mode) => launch(file, mode, context) };
    },
    [agendaId, savedRecords, canEdit, enabled, versionId, launch]
  );
};
